module.exports = __webpack_public_path__ + "static/img/torsoScaled11.e2bfb12b.png";